<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row">
  <crew-form [freighter]="freighter" [date]="date" [crew]="crew" (back)="onBack()" (saved)="onSaved($event)"></crew-form>
</div>

